// composables/useMenuState.js
export const useMenuState = () => {
  const isAllMenuOpen = useState('menu-all-open', () => false)
  const showSubmenu = useState('menu-submenu-open', () => false)

  const closeAllMenus = () => {
    isAllMenuOpen.value = false
    showSubmenu.value = false
  }

  const toggleAllMenu = () => {
    isAllMenuOpen.value = !isAllMenuOpen.value
    if (!isAllMenuOpen.value) {
      showSubmenu.value = false
    }
  }

  const toggleSubmenu = () => {
    showSubmenu.value = !showSubmenu.value
  }

  const openSubmenu = () => {
    showSubmenu.value = true
  }

  const closeSubmenu = () => {
    showSubmenu.value = false
  }

  return {
    isAllMenuOpen,
    showSubmenu,
    closeAllMenus,
    toggleAllMenu,
    toggleSubmenu,
    openSubmenu,
    closeSubmenu
  }
}